var exports = {
  "Y9": "Header__cKmK4B",
  "hE": "Title__AOm2TR",
  "wN": "Number__-CI2qp",
  "En": "Actions__vgeFFK",
  "W8": "Meta__IQaCH6",
  "Qi": "AuthorLink__VbguLb",
  "E": "OthersButton__fBWDgl",
  "ts": "AuthorName__D-XmDN",
  "_O": "AuthorLabel__Kt34ki",
  "LN": "Avatars__DWdZ6t",
  "GX": "ProgressSummary__r3IP33",
  "s$": "Legend__Pl67cq",
  "Jv": "LegendItem__2UbETp",
  "rp": "Swatch__xRCpbA",
  "dp": "ClosedBanner__Lcj6Df",
};

module.exports = exports;
